import { render, staticRenderFns } from "./TagToCreate.vue?vue&type=template&id=801baf36&scoped=true&"
import script from "./TagToCreate.vue?vue&type=script&lang=js&"
export * from "./TagToCreate.vue?vue&type=script&lang=js&"
import style0 from "./TagToCreate.vue?vue&type=style&index=0&id=801baf36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801baf36",
  null
  
)

export default component.exports